import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { REImgMasterCreateRequestDTO, REImgMasterDeleteRequestDTO, REImgMasterDTO, REImgMasterList, REImgMasterReadByIdRequestDTO, REImgMasterReadByMasterIdRequestDTO, REImgMasterUpdateRequestDTO } from "./reImgMaster.interface";
import { Observable } from "rxjs";
import { RealEstateImgMaster_Create, RealEstateImgMaster_Delete, RealEstateImgMaster_ReadAll, RealEstateImgMaster_ReadById, RealEstateImgMaster_ReadByMasterId, RealEstateImgMaster_ReadByMasterType, RealEstateImgMaster_Update } from "src/app/GlobalVariable";

@Injectable({
    providedIn: 'root'
})

export class REImgMasterService {
    private http = inject(HttpClient);

    REImgMaster_Create(data: REImgMasterCreateRequestDTO): Observable<REImgMasterDTO> {
        return this.http.post<REImgMasterDTO>(RealEstateImgMaster_Create, data);
    }

    REImgMaster_Update(data: REImgMasterUpdateRequestDTO): Observable<REImgMasterDTO> {
        return this.http.post<REImgMasterDTO>(RealEstateImgMaster_Update, data);
    }

    REImgMaster_ReadAll(): Observable<REImgMasterList> {
        return this.http.get<REImgMasterList>(RealEstateImgMaster_ReadAll);
    }

    REImgMaster_Delete(data: REImgMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(RealEstateImgMaster_Delete, data);
    }

    REImgMaster_ReadById(data: REImgMasterReadByIdRequestDTO): Observable<REImgMasterDTO> {
        return this.http.post<REImgMasterDTO>(RealEstateImgMaster_ReadById, data);
    }

    REImgMaster_ReadByMasterId(data: REImgMasterReadByMasterIdRequestDTO): Observable<REImgMasterList> {
        return this.http.post<REImgMasterList>(RealEstateImgMaster_ReadByMasterId, data);
    }

    // REImgMaster_ReadByMasterType(data: REImgMasterReadByMasterIdRequestDTO): Observable<REImgMasterList> {
    //     return this.http.post<REImgMasterList>(RealEstateImgMaster_ReadByMasterType, data);
    // }

}